import {FC, memo, useCallback} from "react";
import {Button} from "@material-ui/core";
import {useI18n} from "../../../../i18";

const Footer: FC<{ onClose: () => void; }> = ({onClose}) => {
  const {t} = useI18n();
  const onCancel = useCallback((e) => {
    e.stopPropagation();
    onClose();
    // eslint-disable-next-line
  }, []);
  return (
    <div className="grid-editor-footer">
      <Button
        color="primary"
        type="submit"
      >
        {t('save')}
      </Button>
      <Button
        onClick={onCancel}
      >
        {t('cancel')}
      </Button>
    </div>
  );
};

export default memo(Footer);
